/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { TestLogPowMath__factory } from "./TestLogPowMath__factory";
